import React from "react";
import { DashboardActionMenuIcon } from "components/dashboard-action-menu";
import PropTypes from "prop-types";
import Icon from "components/icon";
import Tooltip from "@material-ui/core/Tooltip";

const ActionButton = ({ className, show = true, url, icon, onClick, disabled = false, disabledTooltipText, tooltipText }) => {
  const button = (
    <DashboardActionMenuIcon
      className={className}
      disabled={disabled}
      disabledTooltipText={disabledTooltipText}
      url={url}
      onClick={onClick}
    >
      <Icon name={icon} />
    </DashboardActionMenuIcon>
  );

  if (!show) return null;

  return tooltipText ? (
    <Tooltip title={tooltipText} arrow>
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

ActionButton.propTypes = {
  /**
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /**
   * Indica si el botón está deshabilitado
   **/
  disabled: PropTypes.bool,
  /**
   * Callback que se llama al hacer click (opcional)
   **/
  onClick: PropTypes.func,
  /**
   * Indica si se muestra el componente
   **/
  show: PropTypes.bool,
  /**
   * Url del icono del menú
   **/
  url: PropTypes.string,
  /**
   * Icono del menú
   **/
  icon: PropTypes.string.isRequired,
  /**
   * Texto para mostrar en un tooltip en caso de que el botón esté deshabilitado.
   * En caso de no haber texto, no se muestra el tooltip
   **/
  disabledTooltipText: PropTypes.string,
  /**
   * Texto para mostrar en un tooltip siempre (independientemente del estado del botón)
   **/
  tooltipText: PropTypes.string,
};

export default ActionButton;
